import ConfigHome from "../../apps/configuration/ConfigHome";
import { initital_state_configuration } from "../../apps/configuration/configurationConstants";
import GenerateOTP from "../../apps/generateOtp";
import { initial_state_generate_otp } from "../../apps/generateOtp/constants";
import HealthStatus from "../../apps/health";
import { initial_state_health_status } from "../../apps/health/constants";
import Distributor from "../../apps/distributor";
import { initial_state_distributor } from "../../apps/distributor/DistributorConstants";
import Banks from "../../apps/bank";
import Products from "../../apps/products";
import Entity from "../../apps/entity";
import Doctors from "../../apps/doctor";
import Hsn from "../../apps/hsn";
import Transport from "../../apps/transport";
import AddProductGeneralTab from "../../apps/products/addProduct/addProductTabs/GeneralTab";
import AddProductMiscellaneousTab from "../../apps/products/addProduct/addProductTabs/MiscellaneousTab";
import AddProductStockOrPricesTab from "../../apps/products/addProduct/addProductTabs/StockOrPricesTab";
import AddBankGeneralTab from "../../apps/bank/addBank/addBankTabs/GeneralTab";
import AddBankMiscellaneousTab from "../../apps/bank/addBank/addBankTabs/MiscellaneousTab";
import { initial_state_products } from "../../apps/products/ProductsConstants";

import Customer from "../../apps/customer";
import { initial_state_customers } from "../../apps/customer/CustomersConstants";
import { initial_state_banks } from "../../apps/bank/BanksConstants";
import { initial_state_entity } from "../../apps/entity/EntityConstants";

import RetailerReports from "../../apps/retailer/RetailerReports";
import { initial_state_retailer_report } from "../../apps/retailer/RetailerReportsConstants";
import Roles from "../../apps/roles";
import { initial_state_roles } from "../../apps/roles/constants";
import { initial_state_users } from "../../apps/users/constant";
import { initial_state_hsn } from "../../apps/hsn/HsnConstants";
import { initial_state_Transport } from "../../apps/transport/TransportConstants";
import Users from "../../apps/users/UsersReports";
import AddDistributorGeneralTab from "../../apps/distributor/addDistributor/addDistributorTabs/GeneralTab";
import AddDistributorAccountTab from "../../apps/distributor/addDistributor/addDistributorTabs/AccountTab";
import AddDistributorLicenseTab from "../../apps/distributor/addDistributor/addDistributorTabs/LicenseTab";
import AddDistributorVisitTab from "../../apps/distributor/addDistributor/addDistributorTabs/VisitsTab";
import StockAudit from "../../stockAudit/StockAudit";
import StockAuditReport from "../../apps/stockAuditReport/StockAuditReport";
import StockTransferReport from "../../apps/stockTransferReport/StockTransferReport";
import StockRequestReport from "../../apps/stockRequestReport/StockRequestReport";
import MedicineWiseStockAuditReport from "../../apps/medicineWiseStockAuditReport/MedicineWiseStockAuditReport";
import Profession from "../../apps/profession/Profession";
import Speciality from "../../apps/speciality/Speciality";
import { initial_state_profession } from "../../apps/profession/ProfessionMasterReportsConstants";
import { initial_state_speciality } from "../../apps/speciality/SpecialityMasterReportsConstants";
import { initial_state_system } from "../../apps/system/constants";
import System from "../../apps/system";
import MedicineWiseStockTransferReport from "../../apps/medicineWiseStockTransferReport/MedicineWiseStockTransferReport";
import MedicineWiseStockRequestReport from "../../apps/medicineWiseStockRequestReport/MedicineWiseStockRequestReport";
import {
  ADD_PRODUCT_GENERAL_TAB,
  ADD_PRODUCT_MISCELLANEOUS_TAB,
  ADD_PRODUCT_STOCK_OR_PRICES_TAB,
  CONFIGURATION_TAB,
  GENERATE_OTP_TAB,
  HEALTH_STATUS_TAB,
  PRODUCTS_TAB,
  DOCTORS_TAB,
  CUSTOMER_TAB,
  RETAILER_REPORTS_TAB,
  ROLES_TAB,
  USERS_TAB,
  BANK_TAB,
  ENTITY_TAB,
  ADD_BANK_GENERAL_TAB,
  ADD_BANK_MISCELLANEOUS_TAB,
  HSN_TAB,
  TRANSPORTATION_TAB,
  DISTRIBUTOR_TAB,
  ADD_DISTRIBUTOR_GENERAL_TAB,
  ADD_DISTRIBUTOR_LICENSE_TAB,
  ADD_DISTRIBUTOR_ACCOUNT_TAB,
  ADD_DISTRIBUTOR_VISIT_TAB,
  STOCK_AUDIT_TAB,
  REPORTS_STOCK_AUDIT,
  REPORTS_STOCK_TRANSFER,
  REPORTS_STOCK_REQUEST,
  REPORTS_MEDICINE_WISE_STOCK_AUDIT,
  PROFESSION_TAB,
  SPECIALITY_TAB,
  ADD_SYSTEM_TAB,
  REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
  REPORTS_MEDICINE_WISE_STOCK_REQUEST,
  ADD_SERVICE_ITEM_TAB,
  REPORTS_DISCOUNT_SLAB,
  REPORTS_DISCOUNT_PROGRAM,
  MANUFACTURER_TAB,
  MANUFACTURER_GROUP_TAB,
  BRANCH_GROUP_TAB,
  REPORTS_FREQUENCY_SLAB_TAB,
  CAC_USER_TAB,
  CAC_ROLES_TAB,
} from "./tabUtilsConstants";
import { initial_state_doctors } from "../../apps/doctor/DoctorConstants";
import { initial_state_stock_audit } from "../../stockAudit/stockAuditConstants";
import { initial_state_stock_audit_report } from "../../apps/stockAuditReport/StockAuditReportConstants";
import { initial_state_stock_transfer_report } from "../../apps/stockTransferReport/StockTransferReportConstants";
import { initial_state_stock_request_report } from "../../apps/stockRequestReport/StockRequestReportConstants";
import { initial_state_medicine_wise_stock_audit_report } from "../../apps/medicineWiseStockAuditReport/MedicineWiseStockAuditReportConstants";
import { initial_state_medicine_wise_stock_transfer_report } from "../../apps/medicineWiseStockTransferReport/MedicineWiseStockTransferReportConstants";
import { initial_state_medicine_wise_stock_request_report } from "../../apps/medicineWiseStockRequestReport/MedicineWiseStockRequestReportConstants";
import { initial_state_service_item } from "../../apps/serviceItems/ServiceItemConstants";
import ServiceItems from "../../apps/serviceItems/index";
import DiscountSlabReport from "../../apps/discountSlabReport/DiscountSlabReport";
import { initial_state_discount_slab_report } from "../../apps/discountSlabReport/DiscountSlabReportConstants";
import { initial_state_manufacturer } from "../../apps/manufacturer/ManufacturerConstants";
import { initial_state_manufacturer_group } from "../../apps/manufacturerGroup/ManufacturerGroupConstants";
import Manufacturer from "../../apps/manufacturer/index";
import ManufacturerGroup from "../../apps/manufacturerGroup";
import DiscountProgramReport from "../../apps/discountProgramReport/DiscountProgramReport";
import { initial_state_discount_program_report } from "../../apps/discountProgramReport/DiscountProgramReportConstants";
import BranchGroup from "../../apps/branchGroup/index";
import { initial_state_branch_group } from "../../apps/branchGroup/BranchGroupConstants";
import FrequencySlabReport from "../../apps/frequencySlabReport/FrequencySlabReport";
import { initial_state_frequency_slab_report } from "../../apps/frequencySlabReport/FrequencySlabReportConstants";
import CacUser from "../../apps/cacUser/CacUser";
import { initial_state_cac_user } from "../../apps/cacUser/CacUserConstants";
import CacRoles from "../../apps/cacRoles";
import { initial_state_cac_roles } from "../../apps/cacRoles/constants";
export const getComponent = (type) => {
  switch (type) {
    case USERS_TAB:
      return Users;
    case ROLES_TAB:
      return Roles;
    case PRODUCTS_TAB:
      return Products;
    case DOCTORS_TAB:
      return Doctors;
    case CUSTOMER_TAB:
      return Customer;
    case ENTITY_TAB:
      return Entity;
    case HSN_TAB:
      return Hsn;
    case TRANSPORTATION_TAB:
      return Transport;
    case GENERATE_OTP_TAB:
      return GenerateOTP;
    case HEALTH_STATUS_TAB:
      return HealthStatus;
    case RETAILER_REPORTS_TAB:
      return RetailerReports;
    case CONFIGURATION_TAB:
      return ConfigHome;
    case ADD_PRODUCT_MISCELLANEOUS_TAB:
      return AddProductMiscellaneousTab;
    case ADD_PRODUCT_GENERAL_TAB:
      return AddProductGeneralTab;
    case ADD_PRODUCT_STOCK_OR_PRICES_TAB:
      return AddProductStockOrPricesTab;
    case BANK_TAB:
      return Banks;
    case ADD_BANK_GENERAL_TAB:
      return AddBankGeneralTab;
    case ADD_BANK_MISCELLANEOUS_TAB:
      return AddBankMiscellaneousTab;
    case DISTRIBUTOR_TAB:
      return Distributor;
    case ADD_DISTRIBUTOR_GENERAL_TAB:
      return AddDistributorGeneralTab;
    case ADD_DISTRIBUTOR_LICENSE_TAB:
      return AddDistributorLicenseTab;
    case ADD_DISTRIBUTOR_ACCOUNT_TAB:
      return AddDistributorAccountTab;
    case ADD_DISTRIBUTOR_VISIT_TAB:
      return AddDistributorVisitTab;
    case STOCK_AUDIT_TAB:
      return StockAudit;
    case REPORTS_STOCK_AUDIT:
      return StockAuditReport;
    case REPORTS_STOCK_TRANSFER:
      return StockTransferReport;
    case REPORTS_STOCK_REQUEST:
      return StockRequestReport;
    case REPORTS_MEDICINE_WISE_STOCK_AUDIT:
      return MedicineWiseStockAuditReport;
    case REPORTS_DISCOUNT_SLAB:
      return DiscountSlabReport;
    case REPORTS_DISCOUNT_PROGRAM:
      return DiscountProgramReport;
    case PROFESSION_TAB:
      return Profession;
    case SPECIALITY_TAB:
      return Speciality;
    case ADD_SYSTEM_TAB:
      return System;
    case REPORTS_MEDICINE_WISE_STOCK_TRANSFER:
      return MedicineWiseStockTransferReport;
    case REPORTS_MEDICINE_WISE_STOCK_REQUEST:
      return MedicineWiseStockRequestReport;
    case ADD_SERVICE_ITEM_TAB:
      return ServiceItems;
    case MANUFACTURER_TAB:
      return Manufacturer;
    case MANUFACTURER_GROUP_TAB:
      return ManufacturerGroup;
    case BRANCH_GROUP_TAB:
      return BranchGroup;
    case REPORTS_FREQUENCY_SLAB_TAB:
      return FrequencySlabReport;
    case CAC_USER_TAB:
      return CacUser;
    case CAC_ROLES_TAB:
      return CacRoles;
    default:
      return null;
  }
};

export const configureInitialState = (type, props) => {
  let __return = {};

  switch (type) {
    case USERS_TAB:
      __return = initial_state_users;
      break;
    case ROLES_TAB:
      __return = initial_state_roles;
      break;
    case PRODUCTS_TAB:
      __return = initial_state_products;
      break;
    case DOCTORS_TAB:
      __return = initial_state_doctors;
      break;
    case CUSTOMER_TAB:
      __return = initial_state_customers;
      break;
    case ENTITY_TAB:
      __return = initial_state_entity;
      break;
    case HSN_TAB:
      __return = initial_state_hsn;
      break;
    case TRANSPORTATION_TAB:
      __return = initial_state_Transport;
      break;
    case GENERATE_OTP_TAB:
      __return = initial_state_generate_otp;
      break;
    case HEALTH_STATUS_TAB:
      __return = initial_state_health_status;
      break;
    case RETAILER_REPORTS_TAB:
      __return = initial_state_retailer_report;
      break;
    case CONFIGURATION_TAB:
      __return = initital_state_configuration;
      break;
    case BANK_TAB:
      __return = initial_state_banks;
      break;
    case DISTRIBUTOR_TAB:
      __return = initial_state_distributor;
      break;
    case STOCK_AUDIT_TAB:
      __return = initial_state_stock_audit;
      break;
    case REPORTS_STOCK_AUDIT:
      __return = initial_state_stock_audit_report;
      break;
    case REPORTS_STOCK_TRANSFER:
      __return = initial_state_stock_transfer_report;
      break;
    case REPORTS_STOCK_REQUEST:
      __return = initial_state_stock_request_report;
      break;
    case REPORTS_MEDICINE_WISE_STOCK_AUDIT:
      __return = initial_state_medicine_wise_stock_audit_report;
      break;
    case REPORTS_DISCOUNT_SLAB:
      __return = initial_state_discount_slab_report;
      break;
    case REPORTS_DISCOUNT_PROGRAM:
      __return = initial_state_discount_program_report;
      break;
    case PROFESSION_TAB:
      __return = initial_state_profession;
      break;
    case SPECIALITY_TAB:
      __return = initial_state_speciality;
      break;
    case ADD_SYSTEM_TAB:
      __return = initial_state_system;
      break;
    case REPORTS_MEDICINE_WISE_STOCK_TRANSFER:
      __return = initial_state_medicine_wise_stock_transfer_report;
      break;
    case REPORTS_MEDICINE_WISE_STOCK_REQUEST:
      __return = initial_state_medicine_wise_stock_request_report;
      break;
    case ADD_SERVICE_ITEM_TAB:
      __return = initial_state_service_item;
      break;
    case MANUFACTURER_TAB:
      __return = initial_state_manufacturer;
      break;
    case MANUFACTURER_GROUP_TAB:
      __return = initial_state_manufacturer_group;
      break;
    case BRANCH_GROUP_TAB:
      __return = initial_state_branch_group;
      break;
    case REPORTS_FREQUENCY_SLAB_TAB:
      __return = initial_state_frequency_slab_report;
      break;
    case CAC_USER_TAB:
      __return = initial_state_cac_user;
      break;
    case CAC_ROLES_TAB:
      __return = initial_state_cac_roles;
      break;
    default:
      __return = {};
  }

  if (props) {
    __return = { ...__return, props };
  }
  return __return;
};
